import { Button } from '@mui/material';
import { sharedStyles } from '../../utils/Style';

type ButtonColumnProps = {
  label: string;
  onClick?: () => void;
};

export const ButtonColumn = (props: ButtonColumnProps) => {
  return (
    <Button
      sx={{ ...sharedStyles.buttonText }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        props.onClick?.();
      }}
    >
      {props.label}
    </Button>
  );
};
